import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { tap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { ProductView } from 'src/app/classes/ProductView';

@Injectable({
  providedIn: 'root'
})
export class TipoProductosService {

  constructor(private http: HttpClient) { }

  public getListaTiposProductos(): Observable<ProductView> {
    const endpoint: string = "../../../assets/Endpoints/Response/getListaTiposProductos.json";
    return this.http.get<any>(endpoint)
      .pipe(
        tap(() => { })
      );
  }
}
